<template>
  <div class="inner-box">
    <div class="content-name">
      <h2 class="dp-ib">{{ title }}</h2>
      <div class="btn-wrap btn-type1 clearfix">
        <button class="btn-size btn-blue fl_left" @click="goSearch"><span class="btn-icon"><i
              class="fas fa-pen-alt"></i></span> 검색
        </button>
      </div>
    </div>

    <!-- 검색조건 영역 -->
    <div class="desc-content search-border">
      <div class="item desc-left">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">사업장</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.businessAreaCd">
              <option value=''>==전체==</option>
              <option v-for="item in businessAreaCds" :key="item.businessAreaCd" :value="item.businessAreaCd"
                v-text="item.businessAreaNm" />
            </b-select>
          </div>
        </div>

        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문목적</span>
          </div>
          <div class="desc" style="width: 70%">
            <b-select class="select is-fullwidth" v-model="form.purpose">
              <option value=''>==전체==</option>
              <option v-for="item in purposes" :key="item.key" :value="item.key" v-text="item.value" />
            </b-select>
          </div>
        </div>
      </div>
      <div class="item desc-center">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">방문일</span>
          </div>
          <div class="desc">
            <div class="datepicker w-type-ymd02">
              <input type="text" class="input date sDate" id="apprDateFrom" autocomplete="off" v-model="form.startTime"
                @keyup="dateFormat($event)" maxlength="8" />
            </div>
            <span class="wave"> ~ </span>
            <div class="datepicker w-type-ymd02">
              <input type="text" class="input date sDate" id="apprDateTo" autocomplete="off" v-model="form.endTime"
                @keyup="dateFormat($event)" maxlength="8" />
            </div>

            <div class="dp-ib fl_left" style="padding-left: 10px;">
              <input type="radio" id="radio01" v-model="form.dateStd" value="D" @click="radioBtn('D')" />
              <label for="radio01" class="NotoM">일별</label>
            </div>
            <div class="dp-ib fl_left">
              <input type="radio" id="radio02" v-model="form.dateStd" value="M" @click="radioBtn('M')" />
              <label for="radio02" class="NotoM">월별</label>
            </div>
          </div>
        </div>

        <search-dept title="방문부서" v-model="form"
          :options="{ type: '01', deptCd: 'visitDept', deptNm: 'deptNm', authorize: true }" @submit="goSearch"
          style="width: 100%;" />
      </div>
      <div class="item desc-right">
        <div class="desc-item">
          <div class="tit">
            <span class="label-tit">회사명</span>
          </div>
          <div class="desc" style="width: 70%">
            <input class="input Rt-M tal" style="width:300px;" type="text" v-model="form.visitorComp" />
          </div>
        </div>
      </div>
    </div>

    <!-- 그래프01 -->
    <div class="desc-content search-border" style="height: 390px;">
      <div class="graph">
        <div class="big">
          <bar-chart :chart-data="datacollection1" :options="mixedOptions"
            :styles="{ width: 'auto', height: '350px', position: 'relative' }"></bar-chart>
        </div>
      </div>
    </div>
    <!-- 그래프01 -->

    <!-- 그래프02 -->
    <div class="desc-content search-border" style="height: 390px;">
      <div class="graph">
        <div class="big">
          <bar-chart :chart-data="datacollection2" :options="mixedOptions2"
            :styles="{ width: 'auto', height: '350px', position: 'relative' }"></bar-chart>
        </div>
      </div>
    </div>
    <!-- 그래프02 -->

    <!-- 그리드 테이블 -->
    <div class="table-area" style="clear: both;">
      <div class="table-b">
        <div class="table-header">
          <div class="table-name">
            <h3 class="ico_table_name">
              방문통계
            </h3>
          </div>
          <div class="btn-wrap btn-type1 clearfix">
            <button class="btn-size btn-excel" @click="saveExcel">엑셀다운로드</button>
          </div>
        </div>
        <!-- 그리드 영역 -->
        <div class="grid-wrap">
          <dhx-grid ref="grid" v-model="gridDataList" :config="config"
            @constructGridSuccessful="constructGridSuccessful" />
        </div>
        <!-- 그리드 영역 -->
      </div>
    </div>
    <!-- 그리드 테이블 -->
  </div>
</template>

<script>
import mixin from '@/mixin';
import mixinSlip from '@/mixin/slip';
import _ from 'lodash'
import DhxGrid from '@/components/DhxGrid.vue';
import DhxCalendar from '@/components/DhxCalendar.vue'

import BarChart from '@/components/chart/VerticalBarChart';
import 'chartjs-plugin-annotation';
import 'chartjs-plugin-labels';

export default {
  name: 'VisitStatisticsPeriod',
  components: { DhxGrid, DhxCalendar, BarChart },
  mixins: [mixin, mixinSlip],
  data() {
    return {
      title: '기간별통계',
      config: {
        columns: [
          { id: 'cnt1', type: 'ro', align: 'center', sort: 'date', value: '날짜', width: 100 },
          { id: 'cnt2', type: 'ro', align: 'center', sort: 'int', value: '전체방문건수', width: 100 },
          { id: 'cnt3', type: 'ro', align: 'center', sort: 'int', value: '방문완료건수', width: 100 },
          { id: 'cnt4', type: 'ro', align: 'center', sort: 'int', value: '방문신청인원수', width: 100 },
          { id: 'cnt5', type: 'ro', align: 'center', sort: 'int', value: '실제방문인원수', width: 100 },
          { id: 'cnt6', type: 'ro', align: 'center', sort: 'int', value: '방문차량건수', width: 100 },
        ],
        height: 350,
        enablePaging: false,
        pagingSize: 8,
        afterRefreshData(grid, data) {
          this.$nextTick(() => {
          })
        }
      },
      datacollection1: null,
      datacollection2: null,
      businessAreaCds: [],
      purposes: [],
      gridDataList: [],
      chartData1: [],
      chartData2: [],
      mixedOptions: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return ''/*`${args.value}`*/;
            },
            //fontColor: ['green', 'white'],
            precision: 2
          },
        },
        title: {
          display: true,
          text: '총방문건수',
          fontSize: 18,
          fontColor: 'black',
          fontStyle: 'bold'
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: 'black',
            fontStyle: 'bold'
          }

        },
        tooltips: {
          //enabled: true,
          //mode: 'nearest'
        },
        animation: {
          //duration: 10,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 5,
            bottom: 0
          }
        },
        elements: {
          center: {
            //text: this.getRandomInt(),
            //color: 'black', //Default black
            fontStyle: 'Helvetica', //Default Arial
            //padding: 40, //Default 20 (as a percentage)
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              padding: 13,
              fontColor: 'black',
              fontStyle: 'bold'
            }

          }],
          yAxes: [{
            ticks: {
              fontColor: 'black',
              fontStyle: 'bold',
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: '방문건수',
              fontColor: 'black',
              fontStyle: 'bold',
              //fontSize : 12,
            },

          }]
        },
        responsive: true,
        maintainAspectRatio: false
      },
      mixedOptions2: {
        plugins: {
          labels: {
            //render: 'percentage',
            render: (args) => {
              return ''/*`${args.value}`*/;
            },
            //fontColor: ['green', 'white'],
            precision: 2
          },
        },
        title: {
          display: true,
          text: '총방문객수(방문완료건 기준)',
          fontSize: 18,
          fontColor: 'black',
          fontStyle: 'bold'
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: 'black',
            fontStyle: 'bold'
          }

        },
        tooltips: {
          //enabled: true,
          //mode: 'nearest'
        },
        animation: {
          //duration: 10,
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 5,
            bottom: 0
          }
        },
        elements: {
          center: {
            //text: this.getRandomInt(),
            //color: 'black', //Default black
            fontStyle: 'Helvetica', //Default Arial
            //padding: 40, //Default 20 (as a percentage)
          }
        },
        scales: {
          xAxes: [{
            ticks: {
              padding: 13,
              fontColor: 'black',
              fontStyle: 'bold'
            }

          }],
          yAxes: [{
            ticks: {
              fontColor: 'black',
              fontStyle: 'bold',
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: '방문객수',
              fontColor: 'black',
              fontStyle: 'bold',
              //fontSize : 12,
            },

          }]
        },
        responsive: true,
        maintainAspectRatio: false
      },
      form: {
        startTime: this.$moment().add(-1, 'month').add(1, 'day').format('YYYY-MM-DD'),
        endTime: this.$moment().format('YYYY-MM-DD'),
        dateStd: 'D',
        businessAreaCd: '',
        purpose: '',
        visitorComp: '',
        visitDept: '',
      },
    };
  },
  methods: {
    dateFormat(e) {
      var value = e.target.value
      e.target.value = value.replace(/[^0-9]/g, "")

      if (e.target.value.length == 8) {
        e.target.value = e.target.value.substring(0, 4) + "-" + e.target.value.substring(4, 6) + "-" + e.target.value.substring(6, 8)
      }
    },
    constructGridSuccessful(grid) {
    },
    calendarLoad() {
      const iljinCalendar1 = new dhtmlXCalendarObject('apprDateFrom')
      iljinCalendar1.setDate(new Date())
      iljinCalendar1.setDateFormat("%Y-%m-%d")
      iljinCalendar1.attachEvent('onChange', () => this.form.startTime = this.$refs.apprDateFrom.getFormatedDate())
      iljinCalendar1.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.startTime = this.$refs.apprDateFrom.getFormatedDate() } })
      this.$refs.apprDateFrom = iljinCalendar1

      const iljinCalendar2 = new dhtmlXCalendarObject('apprDateTo')
      iljinCalendar2.setDate(new Date())
      iljinCalendar2.setDateFormat("%Y-%m-%d")
      iljinCalendar2.attachEvent('onChange', () => this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d"))
      iljinCalendar2.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d") } })
      this.$refs.apprDateTo = iljinCalendar2
    },
    radioBtn(flag) {
      this.form.dateStd = flag

      if (flag == 'D') {
        this.form.startTime = this.$moment(this.form.startTime).format('YYYY-MM-DD')
        this.form.endTime = this.$moment(this.form.endTime).format('YYYY-MM-DD')

        const iljinCalendar1 = new dhtmlXCalendarObject('apprDateFrom')
        iljinCalendar1.setDate(new Date(this.form.startTime))
        iljinCalendar1.setDateFormat("%Y-%m-%d")
        iljinCalendar1.attachEvent('onChange', () => this.form.startTime = this.$refs.apprDateFrom.getFormatedDate())
        iljinCalendar1.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.startTime = this.$refs.apprDateFrom.getFormatedDate() } })
        iljinCalendar1.hideTime()
        this.$refs.apprDateFrom = iljinCalendar1

        const iljinCalendar2 = new dhtmlXCalendarObject('apprDateTo')
        iljinCalendar2.setDate(new Date(this.form.endTime))
        iljinCalendar2.setDateFormat("%Y-%m-%d")
        iljinCalendar2.attachEvent('onChange', () => this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d"))
        iljinCalendar2.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m-%d") } })
        iljinCalendar2.hideTime()
        this.$refs.apprDateTo = iljinCalendar2

      } else if (flag == 'M') {
        this.form.startTime = this.$moment(this.form.startTime).format('YYYY-MM')
        this.form.endTime = this.$moment(this.form.endTime).format('YYYY-MM')

        const iljinCalendar1 = new dhtmlXCalendarObject('apprDateFrom')
        iljinCalendar1.setDate(new Date(this.form.startTime))
        iljinCalendar1.setDateFormat("%Y-%m")
        iljinCalendar1.attachEvent('onChange', () => this.form.startTime = this.$refs.apprDateFrom.getFormatedDate())
        iljinCalendar1.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.startTime = this.$refs.apprDateFrom.getFormatedDate() } })
        iljinCalendar1.hideTime()
        this.$refs.apprDateFrom = iljinCalendar1

        const iljinCalendar2 = new dhtmlXCalendarObject('apprDateTo')
        iljinCalendar2.setDate(new Date(this.form.endTime))
        iljinCalendar2.setDateFormat("%Y-%m")
        iljinCalendar2.attachEvent('onChange', () => this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m"))
        iljinCalendar2.attachEvent("onButtonClick", (d) => { if (d === null) { this.form.endTime = this.$refs.apprDateTo.getFormatedDate("%Y-%m") } })
        iljinCalendar1.hideTime()
        this.$refs.apprDateTo = iljinCalendar2

      }
    },
    //사업장
    getBusinessAreaCdCombo() {
      this.$http.get('/api/auth/user/business', {
        params: {
          empNo: this.$store.state.loginInfo.loginId
        }
      }).then(response => {
        this.businessAreaCds = response.data
      })
    },
    //방문목적
    getPurposeCdCombo() {
      this.$http.get(`/api/code/combo`, { params: { groupCd: "PURPOSE_CD" } })
        .then(response => {
          this.purposes = response.data
        })
    },
    saveExcel() {
      if (_.isEmpty(this.gridDataList)) {
        this.$swal({ type: 'warning', text: '엑셀데이터없음' })
        return false
      }

      this.downloadExcel(this.$refs.grid)
    },
    goSearch() {
      const stDt = this.$moment(this.form.startTime)
      const enDt = this.$moment(this.form.endTime)
      const diff = this.$moment.duration(enDt.diff(stDt)).asDays()

      if (this.form.dateStd == 'D') {
        if (diff > 30) {
          this.$swal({ type: 'warning', text: '선택가능기간은 최대 31일입니다' })
          return
        }
      } else if (this.form.dateStd == 'M') {
        if (diff > 365) {
          this.$swal({ type: 'warning', text: '선택가능기간은 최대 12개월입니다' })
          return
        }
      }

      const param = JSON.parse(JSON.stringify(this.form))
      if (!this.validation(param)) return

      this.$store.commit('loading')
      try {
        this.$http.post(`/api/statistics/period`, param)
          .then(response => {
            this.chartData1 = response.data.firstChart
            this.chartData2 = response.data.secondChart
            this.gridDataList = response.data.grid

            this.$store.commit('finish')

            this.fillData()

          })
          .catch((e) => {
            console.error(e.toString())
            this.$swal({ type: 'error', text: '검색 오류' })
            this.chartData1 = []
            this.chartData2 = []
            this.gridDataList = []
            this.$store.commit('finish')
          })
      } catch (e) {
        this.$store.commit('finish')
      }
    },
    validation(param) {
      if (!param.startTime || !param.endTime) {
        this.$swal({ type: 'warning', text: '작업일자를 선택해 주세요.' })
        return false
      }
      return true
    },
    fillData() {
      this.datacollection1 = {
        labels: this.chartData1.label,
        datasets: [
          {
            type: 'line',
            label: '방문완료건수',
            borderColor: '#FF9A0B',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: '#FF9A0B',
            data: this.chartData1.totalDoneCnt,

          },
          {
            type: 'bar',
            label: '전체방문건수',
            backgroundColor: '#3e82ff',
            barPercentage: 1,
            barThickness: 20,
            maxBarThickness: 30,
            data: this.chartData1.totalCnt,
          },
        ]
      }

      this.datacollection2 = {
        labels: this.chartData2.label2,
        datasets: [
          {
            type: 'line',
            label: '차량수',
            borderColor: '#0040ff',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: '#0040ff',
            data: this.chartData2.visitorsCarCnt,

          },
          {
            type: 'line',
            label: '실방문인원수',
            borderColor: '#ffc900',
            backgroundColor: 'rgba(0, 0, 0, 0)',
            pointBackgroundColor: '#ffc900',
            data: this.chartData2.visitorsCnt,

          },
          {
            type: 'bar',
            label: '방문신청인원수',
            backgroundColor: '#1ac83e',
            barPercentage: 1,
            barThickness: 20,
            maxBarThickness: 30,
            data: this.chartData2.totalVisitorsCnt,
          },
        ]
      }
    },
  },

  created() {
    //Admin 권한 체크
    if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
      setTimeout(()=> {
        this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
            ,100});
      this.$router.push({path: `/ijmt`});
    };
  },

  mounted() {
    /*콤보조회*/
    this.getBusinessAreaCdCombo()
    this.getPurposeCdCombo()
    /*차트 셋팅*/
    /*그리드조회*/
    this.calendarLoad()
    this.radioBtn(this.form.dateStd)
    this.goSearch()
  }
}
</script>

<style scoped>
.desc-content:after {
  clear: both;
  content: '';
  display: block;
}

.btn-wrap {
  margin-bottom: 20px;
}

.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}

.desc-content .item {
  float: left;
}

.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}

.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}

.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}

.desc-content .item .desc-item .label-tit {
  font-family: 'NotoM';
  color: #222;
  font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-center .desc-item {
  padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: '';
  display: block;
}

.desc-content .item.desc-center .desc-item .desc:after {
  clear: both;
  content: '';
  display: block;
}

.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-center .desc-item .desc .datepicker {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .item.desc-center .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: '';
  display: block;
}

.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-center .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-center .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}

.desc-content .item.desc-left {
  width: 30%;
  padding-right: 40px;
}

.desc-content .item.desc-center {
  width: 45%;
  padding-right: 40px;
}

.desc-content .item.desc-right {
  width: 25%;
}

.search-area input {
  position: relative;
}

.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}

.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}

.search-border .td-s-thumb.search-area>input,
.search-border .td-s-thumb.search-area>.ip-box .search-border .td-s-thumb.search-area>button {
  float: left;
}

.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}

.remove_text {
  margin-left: 0;
}

.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
  max-height: 0px;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}

.big {
  width: auto;
}

.small {
  max-width: 200px;
}

/*
    .desc{
        margin-left:40px;
    }*/
</style>
